<template>
    <ItemDialog ref="dialogRef" imageType="alert" :initialOpen="false">
      <template v-slot:content-area>
        <h2>運行対象時間外となっております。<br>なお、運行日は土休日等に限られていますのでご確認ください</h2>
      </template>
      <template v-slot:button-area>
        <ItemButton
          label="閉じる"
          actionType="btn-cancel"
          @clicked="closeDialog()"
        />
      </template>
    </ItemDialog>
</template>
<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";
export default {
  name: "DialogNotOpenService",
  setup() {
    const dialogRef = ref(null);
    const openDialog = () => {
      dialogRef.value.open();
    };
    const closeDialog = () => {
      dialogRef.value.close();
    };
    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>